// stores/counter.ts
import {defineStore} from 'pinia'
import {ref} from "vue";
import {NotificationEntity} from "@/entities/NotificationEntity";
import UserEntity, {MeEntity} from "@/entities/UserEntity";
import {useApiStore} from "@/stores/apiStore";

export let useNotificationsStore = defineStore('notifications', () => {

	let {api} = useApiStore();

	let notifications = ref<NotificationEntity[]>([]);
	let unread = ref<number>(0);

	let timeout : any = null;
	let active : boolean = false;

	function filterOnlyNews(newArray : NotificationEntity[], oldArray : NotificationEntity[]){

		return newArray.filter(item => {
			return !oldArray.find(sub => sub.id === item.id);
		})

	}

	async function update(){

		let {items} = await api.getNotifications(1, 100, {
			field : 'id',
			mode : 'desc'
		});

		let newest = filterOnlyNews(items, notifications.value);

		notifications.value.unshift(...newest);
		unread.value = unread.value + newest.length;

	}

	async function readAll(){

		await api.readNotifications();

		unread.value = 0;

	}

	function startUpdating(){

		active = true;

		timeout = setTimeout(async function b(){

			await update();

			if(active){
				timeout = setTimeout(b, 1000);
			}

		}, 1000);


	}

	function stopUpdating(){

		if(timeout){
			clearTimeout(timeout);

			timeout = null;
		}

		active = false;

	}

	return {
		startUpdating,
		stopUpdating,
		update,
		readAll,
		notifications,
		unread
	}


});